const DOCUMENT = 'ADMIN_TERMS_PRIVACY_';

const actions = {
  CANCEL: DOCUMENT + 'CANCEL',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  TOUCH: DOCUMENT + 'TOUCH',

  cancel: () => ({ type: actions.CANCEL }),
  changeProperty: payload => ({ type: actions.CHANGE_PROPERTY, payload }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
  loadData: payload => ({ type: actions.LOAD, payload }),
  loadDataSuccess: payload => ({ type: actions.LOAD_SUCCESS, payload }),
  save: payload => ({ type: actions.SAVE, payload }),
  saveSuccess: payload => ({ type: actions.SAVE_SUCCESS, payload }),
  touch: payload => ({ type: actions.TOUCH, payload }),
};

export default actions;
